import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import loadUser from '../action/loadUser';
import Top from "../components/layout/top";
import Left from "../components/layout/left";
import RecruitmentSider from "../components/layout/sider/recruitment";
import Header from "../components/layout/header";
import BreadcrumbBar from "../components/layout/breadcrumb";
import '../assets/common/scss/common.scss'
import { message } from 'antd';
import { Layout, Breadcrumb } from 'antd';
import qs from 'query-string';
import OKRSider from '../components/okr_manage/okr_sider';
import FinancialSider from "../components/layout/sider/financial";

const { Content } = Layout;

let userPromise = null;
class Root extends Component {
	static displayName = 'Root';

	static propTypes = {
		config: PropTypes.object,
		children: PropTypes.any,
		user: PropTypes.object,
	};

	constructor(props) {
		super(props);
	}

	componentWillMount() {
		const query = qs.parse(location.search) || {};
		userPromise = this.props.loadUser(query["token"]);
	}

	componentDidMount() {

	}

	render() {
		const {relyLoginState, template} = this.props.config;
		if (relyLoginState) {
			if (this.props.user.isLogin === null) // 接口请求中, 加载loading框
			{
				// console.log("isFetching");
				return (null);
			}
			else if (this.props.user.isFail === false) // 接口请求失败，刷新页面
			{
				return (null);
			}
			else if (this.props.user.isLogin === false) // 未登录状态
			{
				message.error('请先登录', 1, function () {
					window.location.href = '/login/login.html?redirectUrl=' + location.pathname;
				});
			}
		}
		let children = React.cloneElement(this.props.children);
		if (relyLoginState) {
			children = React.cloneElement(children, {userPromise, user: this.props.user});
		}

		if (template === 1 && this.props.user.isLogin === true) //使用template模板默认
		{
			return (
					<Layout>
						<Header user={this.props.user}></Header>
						<Layout className="ant-layout ant-layout-has-sider">
							<Left user={this.props.user}/>
							<Layout style={{ padding: '0 24px 24px' }}>
								<Breadcrumb style={{ margin: '12px 0' }}>
								</Breadcrumb>
								<Content style={{ background: '#fff', padding: 24, margin: 0, minHeight: 280 }}>
									{children}
								</Content>
							</Layout>
						</Layout>
					</Layout>
			);
		}
		else if (template === 2 && this.props.user.isLogin === true) {
			return (
				<div id="app-wrapper">
					<Header user={this.props.user}></Header>
					{children}
				</div>
			)
		}
		else if (template === 3 && this.props.user.isLogin === true) {
			return (
				<div id="app-wrapper">
					<Header user={this.props.user}></Header>
					<BreadcrumbBar user={this.props.user}></BreadcrumbBar>
					{children}
				</div>
			)
		}
		else if (template === 4 && this.props.user.isLogin === true) {
			return (
				<Layout>
					<Header user={this.props.user}></Header>
					<Layout className="ant-layout ant-layout-has-sider">
						<RecruitmentSider user={this.props.user}/>
						<Layout style={{ padding: '0 24px 24px' }}>
							<Breadcrumb style={{ margin: '12px 0' }}></Breadcrumb> 
							<Content style={{ background: '#fff', padding: 24, margin: 0, minHeight: 280 }}>
								{children}
							</Content>
						</Layout>
					</Layout>
				</Layout>

			)
		}
		else if (template === 5 && this.props.user.isLogin === true) {
			return (
					<Layout>
						<Header user={this.props.user}></Header>
						<Layout className="ant-layout ant-layout-has-sider">
							<FinancialSider user={this.props.user}/>
							<Layout style={{ padding: '0 24px 24px' }}>
								<Breadcrumb style={{ margin: '12px 0' }}></Breadcrumb>
								<Content style={{ background: '#fff', padding: 24, margin: 0, minHeight: 280 }}>
									{children}
								</Content>
							</Layout>
						</Layout>
					</Layout>

			)
		}
		else {
			return (
					<div>
						{children}
					</div>
			);
		}
	}
}

function mapStateToProps(state) {
	const {user} = state;
	return {
		user
	};
}

export default connect(mapStateToProps, {
	loadUser,
})(Root);



// WEBPACK FOOTER //
// ./src/container/Root.js